/**
 * Handing a file the page made to the browser — the SPA's one download seam.
 *
 * Two callers: the analytics page's CSV export (`pages/studio/analytics/csv.ts`) and the
 * blog editor's Export Markdown (`pages/blog/`). Both have the file in hand already, so
 * this is a `Blob` and an object URL rather than a request — and rather than a `data:`
 * URI, which some browsers refuse past a hundred kilobytes and none of them gives a
 * filename.
 *
 * A seam, beside `navigate.ts`, because jsdom implements neither `createObjectURL` nor
 * a download: a test stubs the two `URL` statics and the anchor's `click`, and asserts
 * what was handed over (`AnalyticsPage.test.tsx` is the pattern).
 */

/**
 * How long the object URL is kept alive after the click.
 *
 * Revoking it in the same tick cancels the download in Chromium: the anchor's click
 * only *schedules* the fetch of the `blob:` URL. A macrotask is enough and costs
 * nothing.
 */
const REVOKE_DELAY_MS = 0

/** Saves `blob` as `filename`, through the browser's own download. */
export function saveFile(filename: string, blob: Blob): void {
  const url = URL.createObjectURL(blob)

  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  anchor.rel = 'noopener'
  anchor.click()

  setTimeout(() => {
    URL.revokeObjectURL(url)
  }, REVOKE_DELAY_MS)
}
